"use client";

import { useEffect } from "react";

import { reportError } from "@/lib/report-error";

import { ErrorState } from "@/components/states/error-state";

/**
 * Root route error boundary (ENGINEERING.md §5). Catches render/runtime errors
 * in the route subtree, reports them, and offers a recovery action.
 */
export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { source: "boundary:root", digest: error.digest });
  }, [error]);

  return (
    <main
      id="main-content"
      className="mx-auto flex min-h-[60vh] max-w-2xl items-center justify-center p-8"
    >
      <ErrorState
        title="Something went wrong"
        description="An unexpected error occurred. You can try again — if it keeps happening, the team has been notified."
        onRetry={reset}
        retryLabel="Try again"
      />
    </main>
  );
}
